<template>
  <div class="home">
    <div>
      <div class="header-item-title">
        <span class="circle"></span>
        <span>基本情况</span>
      </div>
      <header>
        <div class="header-item">
          <div class="header-item-box">
            <img src="./imgs/teacher-icon.svg" alt="" />
            <div class="box-right">
              <div>
                <p class="box-blue">60</p>
                <p>在职教师数</p>
              </div>
              <div>
                <p class="box-blue">1164</p>
                <p>服务学生数</p>
              </div>
            </div>
          </div>
        </div>

        <div class="header-item" style="padding-left: 4%">
          <div class="header-item-box">
            <img src="./imgs/course-icon.svg" alt="" />
            <div class="box-right">
              <div>
                <p class="box-blue">10</p>
                <p>过审课程</p>
              </div>
              <div>
                <p class="box-blue">5</p>
                <p>待审核课程</p>
              </div>
            </div>
          </div>
        </div>

        <div class="header-item" style="padding-left: 6%">
          <div class="header-item-box">
            <img src="./imgs/student-icon.svg" alt="" />
            <div class="box-right">
              <div>
                <p class="box-blue">12</p>
                <p>服务学校数</p>
              </div>
              <div>
                <p class="box-blue">60</p>
                <p>课程开班数</p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <div>
      <div class="header-item-title">
        <span class="circle"></span>
        <span>资金情况</span>
      </div>
      <header>
        <div class="header-item">
          <div class="header-item-box">
            <img
              src="./imgs/home_icon1.png"
              style="height: 52px; wdith: 52px"
              alt=""
            />
            <div class="box-right">
              <div>
                <p class="box-blue">已监管</p>
                <p>资金监管状态</p>
              </div>
            </div>
          </div>
        </div>

        <div class="header-item">
          <div class="header-item-box">
            <img
              src="./imgs/home_icon2.png"
              style="height: 52px; wdith: 52px"
              alt=""
            />
            <div class="box-right">
              <div>
                <p class="box-blue">￥36,756.00</p>
                <p>基本账户余额</p>
              </div>
            </div>
          </div>
        </div>

        <div class="header-item">
          <div class="header-item-box">
            <img
              src="./imgs/home_icon3.png"
              style="height: 52px; wdith: 52px"
              alt=""
            />
            <div class="box-right">
              <div>
                <p class="box-blue">￥12,354.00</p>
                <p>本月应付课酬</p>
              </div>
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-item-box">
            <img
              src="./imgs/home_icon4.png"
              style="height: 52px; wdith: 52px"
              alt=""
            />
            <div class="box-right">
              <div>
                <p class="box-blue">￥9,832.00</p>
                <p>本月退费金额</p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    <div class="parts">
      <div class="header-item-title" style="margin-bottom: 30px">
        <span class="circle"></span>
        <span>运营情况</span>
      </div>
      <div class="parts-top">
        <div style="width: 33%" class="parts-top-item">
          <div class="header-item-title">
            <!-- <span class="circle"></span> -->
            <span>课消数</span>
          </div>
        </div>
        <div style="width: 33%" class="parts-top-item">
          <div class="header-item-title">
            <!-- <span class="circle"></span> -->
            <span>订单数</span>
          </div>
        </div>
        <div style="width: 33%" class="parts-top-item">
          <div class="header-item-title">
            <!-- <span class="circle"></span> -->
            <span>好评率</span>
          </div>
        </div>
      </div>
      <div class="parts-bottom">
        <div id="histogram01" class="bottom-item"></div>
        <div id="histogram02" class="bottom-item"></div>
        <div id="histogram03" class="bottom-item"></div>
      </div>
    </div>
     <div class="parts" style="margin-top:50px">
      <div class="parts-top">
        <div style="width: 33%" class="parts-top-item">
          <div class="header-item-title">
            <!-- <span class="circle"></span> -->
            <span>退费数</span>
          </div>
        </div>
        <div style="width: 33%" class="parts-top-item">
          <div class="header-item-title">
            <!-- <span class="circle"></span> -->
            <span>退费原因</span>
          </div>
        </div>
        <div style="width: 33%" class="parts-top-item">
          <div class="header-item-title">
            <!-- <span class="circle"></span> -->
            <span>投诉数</span>
          </div>
        </div>
      </div>
      <div class="parts-bottom">
        <div id="histogram04" class="bottom-item"></div>
        <div id="histogram05" class="bottom-item"></div>
        <div id="histogram06" class="bottom-item"></div>
      </div>
    </div>
     <div class="parts" style="margin-top:50px">
       <div class="header-item-title" style="margin-bottom: 30px">
        <span class="circle"></span>
        <span>服务情况</span>
      </div>
        <div class="servesList">
          <div class="servesList_title">
           <img src="./imgs/home_icon_left.png" alt=""> <span>本月教师课销量排行榜</span><img src="./imgs/home_icon_right.png" alt="">
          </div>
          <ul>
            <li v-for="(item,index) in userList1" :key="item.user_id+index">
              <img class="sort" :src="userSort[index]" style="margin-bottom:-5px" alt="" v-if="index<3">
              <span class="sort" v-if="index>=3">{{index+1}}</span>
              <span>{{item.name}}</span>
              <span>{{item.num}}</span>
            </li>
          </ul>
        </div>
        <div class="servesList">
          <div class="servesList_title">
           <img src="./imgs/home_icon_left.png" alt=""> <span>本月教师出勤率排行榜</span><img src="./imgs/home_icon_right.png" alt="">
          </div>
          <ul>
            <li v-for="(item,index) in userList2" :key="item.user_id+index">
              <img class="sort" :src="userSort[index]" style="margin-bottom:-5px" alt="" v-if="index<3">
              <span class="sort" v-if="index>=3">{{index+1}}</span>
              <span>{{item.name}}</span>
              <span>{{item.num}}</span>
            </li>
          </ul>
        </div>
                <div class="servesList">
          <div class="servesList_title">
           <img src="./imgs/home_icon_left.png" alt=""> <span>本月教师好评率排行榜</span><img src="./imgs/home_icon_right.png" alt="">
          </div>
          <ul>
            <li v-for="(item,index) in userList3" :key="item.user_id+index">
              <img class="sort" :src="userSort[index]" style="margin-bottom:-5px" alt="" v-if="index<3">
              <span class="sort" v-if="index>=3">{{index+1}}</span>
              <span>{{item.name}}</span>
              <span>{{item.num}}</span>
            </li>
          </ul>
        </div>
                <div class="servesList">
          <div class="servesList_title">
           <img src="./imgs/home_icon_left.png" alt=""> <span>本月教师差评率排行榜</span><img src="./imgs/home_icon_right.png" alt="">
          </div>
          <ul>
            <li v-for="(item,index) in userList4" :key="item.user_id+index">
              <img class="sort" :src="userSort[index]" style="margin-bottom:-5px" alt="" v-if="index<3">
              <span class="sort" v-if="index>=3">{{index+1}}</span>
              <span>{{item.name}}</span>
              <span>{{item.num}}</span>
            </li>
          </ul>
        </div>
     </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import * as echarts from "echarts";
export default {
  props: ["info"],
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        name: "",
        title: "",
      },
      tabList: [
        { name: "本周" },
        { name: "本月" },
        { name: "本学期" },
        { name: "本年度" },
      ],
      tabName: "本周",
      userList1:[
        {name:'严姣婷',user_id:'12312', num:'48'},
        {name:'强希礼',user_id:'12882', num:'47'},
        {name:'奚秋叶',user_id:'125552', num:'46'},
        {name:'庄萍雅',user_id:'127772', num:'44'},
        {name:'杨萍蓓',user_id:'1267612',num:'39'},
        {name:'昌琦嘉',user_id:'123412', num:'38'},
        {name:'明环凯',user_id:'128282', num:'37'},
        {name:'习华伊',user_id:'125522', num:'33'},
        {name:'寿歌姣',user_id:'127772', num:'32'},
        {name:'闫媛娣',user_id:'126612',num:'31'},
      ],
       userList2:[
        {name:'昌琦嘉',user_id:'12312',  num:'99%'},
        {name:'明环凯',user_id:'12882',  num:'97%'},
        {name:'强希礼',user_id:'125552', num:'96%'},
        {name:'寿歌姣',user_id:'127772', num:'96%'},
        {name:'习华伊',user_id:'1267612',num:'95%'},
        {name:'奚秋叶',user_id:'123412', num:'94%'},
        {name:'严姣婷',user_id:'128282', num:'93%'},
        {name:'闫媛娣',user_id:'125522', num:'92%'},
        {name:'杨萍蓓',user_id:'127772', num:'91%'},
        {name:'庄萍雅',user_id:'126612', num:'90%'},
      ],
       userList3:[
        {name:'庄萍雅',user_id:'12312',  num:'93%'},
        {name:'杨萍蓓',user_id:'12882',  num:'92%'},
        {name:'闫媛娣',user_id:'125552', num:'90%'},
        {name:'严姣婷',user_id:'127772', num:'88%'},
        {name:'奚秋叶',user_id:'1267612',num:'87%'},
        {name:'习华伊',user_id:'123412', num:'85%'},
        {name:'寿歌姣',user_id:'128282', num:'84%'},
        {name:'强希礼',user_id:'125522', num:'83%'},
        {name:'明环凯',user_id:'127772', num:'82%'},
        {name:'昌琦嘉',user_id:'126612', num:'81%'},
      ],
      userList4:[
        {name:'方九薇',user_id:'12312',  num:'32%'},
        {name:'戚枫滢',user_id:'12882',  num:'27%'},
        {name:'松珊娅',user_id:'125552', num:'24%'},
        {name:'束澜眉',user_id:'127772', num:'17%'},
        {name:'孔静秋',user_id:'1267612',num:'14%'},
        {name:'柯颖凤',user_id:'123412', num:'14%'},
        {name:'红玉园',user_id:'128282', num:'12%'},
        {name:'吉纨竹',user_id:'125522', num:'11%'},
        {name:'包柔凡',user_id:'127772', num:'11%'},
        {name:'姚英梅',user_id:'126612', num:'11%'},
      ],
      userSort:[
        require('@/assets/img/statistical/one.svg'),require('@/assets/img/statistical/two.svg'),require('@/assets/img/statistical/three.svg')
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    async getDataList() {
      let params = {
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
        classId: this.info.classId,
        courseName: this.queryParams.title,
        studentName: this.queryParams.name,
      };
      // let res= await api.studentCourseStatistics(params);
      // if(res.code==='0'){
      // 	this.tableData=res.data?.list || [];
      // 	this.totalPage=res.data?.total || 0;
      // }
      // console.log('学生分布详情',res)
    },
    tabClick(item) {
      this.tabName = item.name;
    },
    toIndex() {
      this.$emit("to-index");
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 折线图 课消数
        let chartDom1 = document.getElementById("histogram01");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          legend: {
            // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine'],
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            // {
            //   name: "学生实际出勤数",
            //   type: "line",
            //   stack: "Total",
            //   data: [150, 232, 161, 234, 190, 230, 210],
            // },
            {
              // name: "学生应出勤数",
              type: "line",
              stack: "Total",
              data: [530, 593, 467, 541, 579, 556, 528,550],
            },
          ],
          color: ["#5BB0FF", "#51D6A6"],
        };
        myChart1.setOption(option1);
        // 圆环图 - 订单数
        let chartDom2 = document.getElementById("histogram02");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          title: {
            zlevel: 0,
            text: ["{value|" + "273个" + "}", "{name|支付完成}","{name|" + "24.38%" + "}"].join("\n"),
            rich: {
              value: {
                color: "#333333",
                fontSize: 18,
                fontWeight: "bold",
                lineHeight: 18,
              },
              name: {
                color: "#666666",
                fontSize: 16,
              },
            },
            top: "center",
            left: "185",
            textAlign: "center",
            textStyle: {
              rich: {
                value: {
                  color: "#333333",
                  fontSize: 24,
                  fontWeight: "bold",
                  lineHeight: 24,
                },
                name: {
                  color: "#666666",
                  lineHeight: 20,
                },
              },
            },
          },
          grid: [{
              left: '10%',
              bottom: '30%',
              top: '10%',
              right: '10%',
              containLabel:true
          }],
          legend: {
            itemHeight: 15,
             itemWidth: 15,
            // data: [],
            // orient: 'vertical',
            left: "center",
            top: "bottom",
            icon: "rect",
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["38%", "50%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: "#fff",
                borderWidth: 0,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value:273, name: "支付完成" },
                { value: 72, name: "待支付" },
                { value: 32, name: "支付失败" },
                { value: 17, name: "退费中" },
                { value: 26, name: "已退费" },
              ],
            },
          ],
          // 圆环颜色
          color: [
            "#51D6A6",
            "#5BB0FF",
            "#F27676",
            "#F49562",
            "#757FFD",
          ],
        };
        myChart2.setOption(option2);
          // 折线图 好评率
        let chartDom3 = document.getElementById("histogram03");
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          legend: {
            // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine'],
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            // {
            //   name: "学生实际出勤数",
            //   type: "line",
            //   stack: "Total",
            //   data: [150, 232, 161, 234, 190, 230, 210],
            // },
            {
              // name: "学生应出勤数",
              type: "line",
              stack: "Total",
              data: [93, 80, 85, 82, 87, 88, 81,85],
            },
          ],
          color: ["#EFD053", "#51D6A6"],
        };
        myChart3.setOption(option3);
          // 折线图 退费数
        let chartDom4 = document.getElementById("histogram04");
        let myChart4 = echarts.init(chartDom4);
        let option4 = {
          legend: {
            // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine'],
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              // name: "学生应出勤数",
              type: "line",
              stack: "Total",
              data: [16, 11, 22, 19, 27, 10, 27,10],
            },
          ],
          color: ["#5BB0FF", "#51D6A6"],
        };
        myChart4.setOption(option4);
        // 圆环图 - 退费原因
        let chartDom5 = document.getElementById("histogram05");
        let myChart5 = echarts.init(chartDom5);
        let option5 = {
          title: {
            zlevel: 0,
            text: ["{value|" + "4个" + "}", "{name|教学效果不佳}","{name|" + "40%" + "}"].join("\n"),
            rich: {
              value: {
                color: "#333333",
                fontSize: 18,
                fontWeight: "bold",
                lineHeight: 18,
              },
              name: {
                color: "#666666",
                fontSize: 16,
              },
            },
            top: "center",
            left: "180",
            textAlign: "center",
            textStyle: {
              rich: {
                value: {
                  color: "#333333",
                  fontSize: 24,
                  fontWeight: "bold",
                  lineHeight: 24,
                },
                name: {
                  color: "#666666",
                  lineHeight: 20,
                },
              },
            },
          },
          legend: {
            itemHeight: 15,
             itemWidth: 15,
            left: "center",
            top: "bottom",
            icon: "rect",
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["38%", "50%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: "#fff",
                borderWidth: 0,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 4, name: "教学效果不佳" },
                { value: 3, name: "中途跟换老师" },
                { value: 3, name: "师资力量" },
              //   { value: 30, name: "退费中" },
              //   { value: 28, name: "已退费" },
              ],
            },
          ],
          // 圆环颜色
          color: [
            "#51D6A6",
            "#5BB0FF",
            "#F27676",
            "#F49562",
            "#757FFD",
          ],
        };
        myChart5.setOption(option5);
          // 折线图 投诉数
        let chartDom6 = document.getElementById("histogram06");
        let myChart6 = echarts.init(chartDom6);
        let option6 = {
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
            ],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              data: [6, 6, 10, 12, 7, 12, 8,12],
            },
          ],
          color: ["#EFD053", "#51D6A6"],
        };
        myChart6.setOption(option6);
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  padding: 30px 30px 30px 30px;
  .header-item-title {
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #4991e1;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  header {
    width: 100%;
    height: 200px;
    display: flex;
    .header-item {
       width: 33%;
       border: 1px solid #eee;
       text-align: center;
       margin: 20px;
       padding-left: 33px;
      .header-item-box {
        display: flex;
        align-items: center;
        margin-top: 50px;
        .box-right {
          display: flex;
          div {
            margin-left: 20px;
          }
          p {
            width: 100%;
            font-size: 14px;
            line-height: 21.33px;
            text-align: center;
            color: #999;
          }
          .box-blue {
            font-weight: bold;
            margin-bottom: 5px;
            font-size: 20px;
            color: #4794e8;
          }
        }
      }
    }
  }
  .parts {
    width: 100%;
    .parts-top {
      display: flex;
      .parts-top-item {
        display: flex;
      }
    }
    .parts-bottom {
      width: 100%;
      height: 300px;
      display: flex;
      .bottom-item {
        width: 50%;
        height: 100%;
      }
    }
    #pie01 {
      width: 370px;
      margin: auto;
    }
    .course-box {
      width: 346px;
      height: 70px;
      border-radius: 4px;
      background: linear-gradient(180deg, #fff 0%, #fff 100%);
      border: 1px solid #eee;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 18px;
        color: #666;
        margin-left: 20px;
      }
    }
    .servesList{
        display: inline-block;
        width: 23%;
        margin: 10px;
        padding: 20px;
        border: 1px solid #eee;
        text-align: center;
        border-radius: 5px;
        ul li{
          // display: flex;
          // justify-content: center;
          vertical-align: middle;
          text-align: center;
          margin: 10px;
          height: 18px;
          line-height: 18px;
          img{
           margin-right: 10px;
          }
          // .sort{
          //   display: inline-block;
          //   width: 60px;
          // }
        }
        span{
          margin: 10px;
        }
       .servesList_title{
         height:14.4px ;
         margin-bottom: 20px;
         font-family: "PingFang SC Medium";
        font-weight: 500;
        font-size: 14px;
        line-height: 14.4px;
        color: #333;
        span{
          margin: 10px;
        }
       }
    }
  }
  .item-title {
    font-size: 16px;
    color: #666;
    display: flex;
    align-items: center;
    margin-left: 20px;
    .square {
      width: 12px;
      height: 12px;
      margin-right: 10px;
    }
    .blue {
      background: #33b1ff;
    }
    .green {
      background: #00daa3;
    }
  }

  .task {
    width: 100%;
    margin-top: 20px;
    .task-bottom {
      margin-top: 20px;
    }
    .table {
      margin-top: 30px;
    }
  }
  .Homeboxtop_nav_tab {
    span {
      width: 100px;
      font-weight: 400;
      font-size: 15px;
      margin-right: 40px;
      cursor: pointer;
      padding-bottom: 15px;
    }
    .active {
      color: #4991e1;
      border-bottom: 3px solid #4991e1;
    }
  }
}
</style>
